<div class="d-flex">
    <div class="percent-bar border rounded w-100"
         [style.background]="complete == 100 ? 'var(--success-light)' : percentBarStyle">

        <div class="percent-text text-center ps-1" title="{{complete | number:'1.0-0'}}% complete"
             [class.ps-1]="complete == 0"
             [ngStyle]="{'width':  complete +'%'}">
            {{complete | number:'1.0-0'}}%
        </div>
    </div>

</div>

